// extracted by mini-css-extract-plugin
module.exports = {"blueskyEmbed":"style_blueskyEmbed__ZTcf5","fallback":"style_fallback__AQFef g-grid-container"};